<template>
  <v-app>
    <AppDrawer/>
    <AppHeader/>
    <v-main>
      <v-container fluid class="fill-height d-flex align-start flex-wrap">
          <div class="w-100">
            <slot/>
          </div>
      </v-container>
    </v-main>
    <AppToast />
  </v-app>

  <v-no-ssr>
    <v-dialog v-model="errorState.dialog" persistent max-width="600px">
      <v-card class="text-center py-5">
        <template v-if="errorState.statusCode === 500">
          <v-card-title class="text-h5">
            Une erreur est survenue
          </v-card-title>
          <v-card-text>
            Veuillez réessayer
          </v-card-text>
        </template>
        <v-card-text class="text-center" v-if="errorState.message">
          <v-code class="font-weight-bold">{{ errorState.message }}</v-code>
        </v-card-text>
        <v-card-text>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="errorState.dialog = false">Fermer</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-no-ssr>
</template>

<script lang="ts" setup>
useConfigPage()
useFrenchLocale()
const {errorState} = useApp();
const {getMe} = useAuth()
getMe();

const campaignStatusesStore = useCampaignStatusesStore()
campaignStatusesStore.init()

const { setupListeners } = useCampaignSync()
setupListeners()
</script>
